/**
 * @file: 层板货架落位y值修正
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../toolkit/index';
import FrontCubeData from '../../frontCubeData/index';

function layerYRectify(shelf: CubeId, posY: PhysicsMeasurement): PhysicsMeasurement {
	let holeSpacing: PhysicsMeasurement = FrontCubeData.getNumberValue(shelf, 'holeSpacing');
    let firstHolePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(shelf, 'firstHolePosY');

	// 如果没有设置步长，原值返回
	if (holeSpacing <= 0) {
		return posY;
	}

    if (posY <= firstHolePosY) {
        return firstHolePosY;
    }

	return Toolkit.stepValue(holeSpacing, posY);
}

export {
    layerYRectify
};
